import { getCookie, setCookie } from "./cookies";
import { hasCookieConsent } from "./consent";

export const VISITOR_ID_COOKIE = "dt_visitor_id";
const MAX_AGE_SECONDS = 60 * 60 * 24 * 365; // ~1 ano

/**
 * Cria o cookie só se o consentimento já foi aceito — sem `'accepted'`,
 * nenhum `dt_visitor_id` é criado (nem lido: se um cookie desse nome já
 * existir de uma sessão anterior mas o consentimento tiver sido revogado
 * entre uma visita e outra, ele deixa de ser usado, ainda que não seja
 * apagado — apagar cookie de terceiro/próprio no logout de consentimento é
 * uma melhoria futura, fora de escopo desta spec).
 */
export function getOrCreateVisitorId(): string | null {
  if (!hasCookieConsent()) return null;
  const existing = getCookie(VISITOR_ID_COOKIE);
  if (existing) return existing;
  const id = crypto.randomUUID();
  setCookie(VISITOR_ID_COOKIE, id, MAX_AGE_SECONDS);
  return id;
}
